/**
 * オフセット付きのスムーズスクロールを実行する関数
 * @param {HTMLElement} element - スクロール先の要素
 * @param {Object} options - スクロールのオプション
 * @param {number} options.duration - アニメーションの時間（ミリ秒）
 * @param {number} options.offset - スクロール位置のオフセット（ピクセル）
 * @example
 * const element = document.querySelector('#target');
 * // ヘッダーの高さ分(80px)オフセットしてスクロール
 * smoothScrollToWithOffset(element, { duration: 1000, offset: -80 });
 */
const smoothScrollToWithOffset = (
    element,
    { duration = 1000, offset = 0 } = {}
) => {
    // 現在のscroll-behaviorの値を保存
    const originalStyle = document.documentElement.style.scrollBehavior;

    // scroll-behaviorを一時的に無効化
    document.documentElement.style.scrollBehavior = "auto";

    const targetPosition =
        element.getBoundingClientRect().top + window.pageYOffset + offset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        const easing = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
        window.scrollTo(0, startPosition + distance * easing(progress));

        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        } else {
            // アニメーション完了後に元のstyleを復元
            document.documentElement.style.scrollBehavior = originalStyle;
        }
    };

    requestAnimationFrame(animation);
};

const mv = document.querySelector(".Mv");
if (mv) {
    window.addEventListener("load", () => {
        mv.classList.add("is-play");

        setTimeout(() => {
            if (scrollY < 5) {
                const pi = document.querySelector("#Pageinfo");
                if (pi) {
                    smoothScrollToWithOffset(pi, {
                        duration: 900,
                        offset:
                            innerWidth > 1024
                                ? 0
                                : -document
                                      .querySelector(".header__left")
                                      .getBoundingClientRect().height,
                    });
                }
            }
        }, 1800);
    });
}
